import React, { useEffect, useState } from "react";
import RequestHandler from "../../util/RequestHandler";
import {
  Table,
  Empty,
  Col,
  Row,
  Button,
  Drawer,
  Popconfirm,
  notification,
  Tooltip,
  message,
  Tabs,
} from "antd";
import {
  OrderedListOutlined,
  EditOutlined,
  DeleteOutlined,
  FormOutlined,
  EyeOutlined,
  FileExcelOutlined,
  FilePdfOutlined,
} from "@ant-design/icons";
import { Link, useHistory } from "react-router-dom";
import { odata, queryHelper } from "../Filters/Helper";
import PurchaseRequestTableFilter from "../Filters/PurchaseRequestTableFilter";
import moment from "moment";
import PurchaseRequestUpdateStatusForm from "./PurchaseRequestUpdateStatusForm";
import config from "../../util/ApiforContext";

const PurchaseRequestList = (props) => {
  const [options, setOptions] = useState({ pageTitle: "TALEP  LİSTESİ" });
  const [purchaseRequests, setPurchaseRequests] = useState({
    data: [],
    loading: true,
    total: 0,
  });
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState(
    queryHelper.getDefaultTableDataQueryOptions()
  );
  const [dataState, setDataState] = useState([{ skip: 0, take: 20 }]);
  const [currentPage, setCurrentPage] = useState(1);
  const [addFormVisibility, setAddFormVisibility] = useState(false);
  const [updateFormVisibility, setUpdateFormVisibility] = useState(false);
  const [updateFormData, setUpdateFormData] = useState({});
  const history = useHistory();
  const [permissions, setPermissions] = useState({
    canAdd: false,
    canUpdate: false,
    canDelete: false,
    canApprove: false,
  });

  useEffect(() => {
    setFilterValues();
    getTableData();
  }, [tableDataQueryOptions]);

  const getTableData = () => {
    setPurchaseRequests({
      ...purchaseRequests,
      loading: true,
    });

    const { skip, take, filter, activeTab } = tableDataQueryOptions;
    const order = "&$orderby=addDate desc";
    let query = "";
    let conditions = ["Name ne 'Diğer'"];
    if (filter) {
      conditions.push(filter);
    }

    if (conditions.length > 0) {
      if (activeTab === "1") {
        conditions.push("isApproved eq true");
      } else if (activeTab === "2") {
        conditions.push("isrejected eq true");
      }
      query = `&$filter=${conditions.join(" and ")}`;
    }

    if (activeTab === "0") {
      RequestHandler.get(
        `/PurchaseRequest?$count=true${query}${order}&$skip=${skip}&$top=${take}`
      ).then((response) => {
        setPurchaseRequests({
          data: response.value,
          loading: false,
          total: response["@odata.count"],
        });
      });
    } else if (activeTab === "1") {
      RequestHandler.get(
        `/PurchaseRequest/GetApprovedHistoryListQueryableOdata?$count=true${query}${order}&$skip=${skip}&$top=${take}`
      ).then((response) => {
        setPurchaseRequests({
          data: response,
          loading: false,
          total: response?.length || 0,
        });
      });
    } else if (activeTab === "2") {
      RequestHandler.get(
        `/PurchaseRequest/GetApprovedHistoryListQueryableOdata?$count=true${query}${order}&$skip=${skip}&$top=${take}`
      ).then((response) => {
        setPurchaseRequests({
          data: response,
          loading: false,
          total: response?.length || 0,
        });
      });
    }
  };

  const onSuccess = () => {
    getTableData();
    setUpdateFormVisibility(false);
  };

  const handleOnClickUpdate = (record) => {
    history.push({
      pathname: `/update-purchase-request/${record.id}`,
    });
  };

  const handleOnClickStatusUpdate = (row) => {
    setUpdateFormData({
      id: row.id,
      name: row.name,
      purchaseRequestStatus: row.statusByte,
    });
    setUpdateFormVisibility(true);
  };

  const setFilterValues = () => {
    const filterValues = {
      ...tableDataQueryOptions.values,
      skip: tableDataQueryOptions.skip,
      take: tableDataQueryOptions.take,
      current: tableDataQueryOptions.current,
      order: tableDataQueryOptions.order,
      filter: tableDataQueryOptions.filter,
    };
    const queryString = queryHelper.getQueryFromValues(filterValues);

    history.replace({
      pathname: window.location.pathname,
      search: queryString,
    });
  };

  const openNotificationWithIcon = (type) => {
    notification[type]({
      message: "Uyarı",
      description: "Pasif olan talepler güncellenemez.",
    });
  };

  const handleOnClickDelete = (row) => {
    // if (row.addUserId !== localStorage.getItem("userId") && !isEditAllowed) {
    //   openNotificationForNotAuthWithIcon("warning");
    //   return;
    // }

    RequestHandler.delete(`/PurchaseRequest/${row.id}`).then((response) => {
      if (response.success) {
        getTableData();
      }
    });
  };

  const handleOnClickView = (record) => {
    history.push({
      pathname: `/update-purchase-request/${record.id}`,
      search: "?mode=view",
    });
  };

  const columns = [
    {
      title: "Talep Kodu",
      dataIndex: "name",
      key: "name",
      align: "left",
      render: (text) => {
        if (!text) return "";

        return (
          <Tooltip title={text}>
            {text.substring(0, 50).length < 50
              ? text.substring(0, 50) + ""
              : text.substring(0, 50) + "..."}
          </Tooltip>
        );
      },
    },
    {
      title: "Talep Başlığı",
      dataIndex: "description",
      key: "description",
      align: "left",
      render: (text) => {
        if (!text) return "";

        return (
          <Tooltip title={text}>
            {text.substring(0, 50).length < 50
              ? text.substring(0, 50) + ""
              : text.substring(0, 50) + "..."}
          </Tooltip>
        );
      },
    },
    {
      title: "Proje Adı/Ünvanı",
      dataIndex: "firmName",
      key: "firmName",
      render: (text) => {
        if (!text) return "";

        return (
          <Tooltip title={text}>
            {text.substring(0, 50).length < 50
              ? text.substring(0, 50) + ""
              : text.substring(0, 50) + "..."}
          </Tooltip>
        );
      },
    },
    {
      title: "Teslimat Deposu",
      dataIndex: "transactionProjectTypeName",
      key: "transactionProjectTypeName",
      render: (text) => {
        if (!text) return "";

        return (
          <Tooltip title={text}>
            {text.substring(0, 50).length < 50
              ? text.substring(0, 50) + ""
              : text.substring(0, 50) + "..."}
          </Tooltip>
        );
      },
    },
    {
      title: "İstenilen Teslimat Tarihi",
      dataIndex: "desiredDeliveryDate",
      key: "desiredDeliveryDate",
      render: (data) => (data ? moment(data).format("DD.MM.YYYY") : "-"),
    },
    {
      title: "Malzeme Alım Amacı ve Kullanilacağı Yer",
      dataIndex: "purposeOfPurchasing",
      key: "purposeOfPurchasing",
      align: "left",
      render: (text) => {
        if (!text) return "";

        return (
          <Tooltip title={text}>
            {text.substring(0, 50).length < 50
              ? text.substring(0, 50) + ""
              : text.substring(0, 50) + "..."}
          </Tooltip>
        );
      },
    },

    {
      title: "Malzeme Hakkında Açıklama ve Detaylar",
      dataIndex: "detailedDescription",
      key: "detailedDescription",
      align: "left",
      render: (text) => {
        if (!text) return "";

        return (
          <Tooltip title={text}>
            {text.substring(0, 50).length < 50
              ? text.substring(0, 50) + ""
              : text.substring(0, 50) + "..."}
          </Tooltip>
        );
      },
    },

    {
      title: "Ekleyen Kullanıcı",
      dataIndex: "addUserName",
      key: "addUserName",
    },
    {
      title: "Eklenme Tarihi",
      dataIndex: "addDate",
      key: "addDate",
      render: (data) =>
        data ? moment(data).format("DD.MM.YYYY HH:mm:ss") : "-",
    },
    {
      title: "Son Güncelleyen Kullanıcı",
      dataIndex: "updateUserName",
      key: "updateUserName",
    },
    {
      title: "Son Güncellenme Tarihi",
      dataIndex: "updateDate",
      key: "updateDate",
      render: (data) => (data ? moment(data).format("DD.MM.YYYY HH:mm") : "-"),
    },
    {
      title: "Durum",
      dataIndex: "purchaseRequestStatusString",
      key: "purchaseRequestStatusString",
    },
    {
      title: "Teklif Mektubu (PDF)",
      dataIndex: "id",
      align: "center",
      render: (data, row) => {
        return (
          <a onClick={() => onClickGeneratePdf(data)}>
            <FilePdfOutlined style={{ color: "red", fontSize: "130%" }} />
          </a>
        );
      },
    },

    {
      title: "Teklif Mektubu (Excel)",
      dataIndex: "id",
      align: "center",
      render: (data, row) => {
        return (
          <a onClick={() => onClickGenerateExcel(data)}>
            <FileExcelOutlined style={{ color: "green", fontSize: "130%" }} />
          </a>
        );
      },
    },
    {
      title: "Görüntüle",
      dataIndex: "id",
      align: "center",
      render: (data, row) =>
        purchaseRequests.total >= 1 && row?.canApprove === true ? (
          <a onClick={() => handleOnClickView(row)}>
            <EyeOutlined style={{ color: "blue", fontSize: "130%" }} />
          </a>
        ) : null,
    },

    {
      title: "Düzenle",
      dataIndex: "id",
      align: "center",
      render: (data, row) =>
        purchaseRequests.total >= 1 && row?.canUpdate === true ? (
          <a onClick={() => handleOnClickUpdate(row)}>
            <EditOutlined style={{ color: "orange", fontSize: "130%" }} />
          </a>
        ) : null,
    },

    {
      title: "Sil",
      dataIndex: "id",
      width: "1%",
      render: (data, row) =>
        row?.canDelete === true ? (
          <Popconfirm
            title="Silmek istiyor musunuz?"
            okText="Evet"
            cancelText="Hayır"
            onConfirm={() => handleOnClickDelete(row)}
          >
            <a style={{ color: "red", fontSize: "130%" }}>
              <DeleteOutlined />
            </a>
          </Popconfirm>
        ) : null,
    },
  ];

  const onClearTableFilter = () => {
    setTableDataQueryOptions({
      ...tableDataQueryOptions,
      skip: 0,
      current: 1,
      filter: "",
      values: {},
      activeTab: tableDataQueryOptions.activeTab,
    });
  };

  const onFinishTableFilter = (query, values) => {
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: 0,
        current: 1,
        filter: query,
        values: values,
        activeTab: tableDataQueryOptions.activeTab,
      };
    });
  };

  const paging = (p, filters, sorter) => {
    let orderBy = "";
    if (sorter.columnKey && sorter.order) {
      orderBy =
        "&" +
        (sorter.order === "ascend"
          ? odata.orderBy(sorter.columnKey)
          : odata.orderByDesc(sorter.columnKey));
    }
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
        activeTab: tableDataQueryOptions.activeTab,
      };
    });
  };

  const dataStateChange = (e) => {
    setPurchaseRequests(e);
  };
  const onClickGeneratePdf = async (id) => {
    try {
      // rawResponse: true veriyoruz ki headers da gelsin
      const response = await RequestHandler.post(
        `/PurchaseRequest/GenerateQuoteOfferPdf/${id}`,
        null,
        false,
        { responseType: "blob", rawResponse: true }
      );

      // Dosya adı header’dan al
      let fileName = "download.pdf";
      const contentDisposition = response.headers["content-disposition"];
      if (contentDisposition) {
        const fileNameMatch = contentDisposition.match(/filename\*?=([^;]+)/);
        if (fileNameMatch && fileNameMatch.length > 1) {
          fileName = decodeURIComponent(
            fileNameMatch[1].replace(/UTF-8''/, "").replace(/"/g, "")
          );
        }
      }

      // PDF blob oluştur ve indir
      const file = new Blob([response.data], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(file);
      const link = document.createElement("a");
      link.href = fileURL;
      link.download = fileName;
      link.click();
      URL.revokeObjectURL(fileURL);
    } catch (err) {
      console.error("PDF indirme hatası", err);
    }
  };

  const exportExcel = () => {
    const hide = message.loading("Excel indiriliyor...", 0);
    const { filter } = tableDataQueryOptions;
    RequestHandler.post(
      `/PurchaseRequestExcel/ExportExcel`,
      { Query: filter == "" ? "" : "$filter=" + filter },
      false,
      {
        rawResponse: true,
      }
    ).then((res) => {
      if (res.status == 200) {
        window.open(
          `${config.apiUrl}/PurchaseRequestExcel/DownloadExcelList?fileName=${
            res.data
          }&t=${RequestHandler.getToken()}`
        );
      }
      hide();
    });
  };

  useEffect(() => {
    RequestHandler.get("/TenantUser/GetApprovalContext").then((res) => {
      if (res?.permissions?.purchaseRequest) {
        setPermissions({
          canAdd: res?.isAdmin || res.permissions.purchaseRequest.canAdd,
          canUpdate: res?.isAdmin || res.permissions.purchaseRequest.canUpdate,
          canDelete: res?.isAdmin || res.permissions.purchaseRequest.canDelete,
          canApprove:
            res?.isAdmin || res.permissions.purchaseRequest.canApprove,
        });
      }
    });
  }, []);

  const onTabChange = (tabKey) => {
    setTableDataQueryOptions({
      ...tableDataQueryOptions,
      skip: 0,
      current: 1,
      activeTab: tabKey,
    });
  };

  const onClickGenerateExcel = async (id) => {
    try {
      // 1. Endpoint'i Excel metoduna yönlendiriyoruz
      // rawResponse: true veriyoruz ki headers da gelsin (Dosya ismini okumak için)
      const response = await RequestHandler.post(
        `/PurchaseRequest/GenerateQuoteOfferExcel/${id}`,
        null,
        false,
        { responseType: "blob", rawResponse: true }
      );

      // 2. Dosya adını header’dan al
      // Eğer header'dan okuyamazsa default olarak "teklif.xlsx" veriyoruz.
      let fileName = "teklif.xlsx";

      const contentDisposition = response.headers["content-disposition"];
      if (contentDisposition) {
        const fileNameMatch = contentDisposition.match(/filename\*?=([^;]+)/);
        if (fileNameMatch && fileNameMatch.length > 1) {
          fileName = decodeURIComponent(
            fileNameMatch[1].replace(/UTF-8''/, "").replace(/"/g, "")
          );
        }
      }

      // 3. Blob oluştururken Excel MIME Type kullanıyoruz
      const file = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const fileURL = URL.createObjectURL(file);
      const link = document.createElement("a");
      link.href = fileURL;
      link.download = fileName; // Backend'den gelen dosya adı buraya set edilir
      link.click();

      // Temizlik
      URL.revokeObjectURL(fileURL);
    } catch (err) {
      console.error("Excel indirme hatası", err);
      // Kullanıcıya toast mesajı vb. gösterebilirsin
    }
  };

  return (
    <>
      <Row>
        <Col xs={24} md={12} lg={16}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <OrderedListOutlined /> {options.pageTitle}
          </p>
        </Col>
        <Col xs={24} md={12} lg={8} style={{ textAlign: "right" }}>
          <Tooltip title="Excel İndir">
            <a
              style={{
                color: "green",
                fontSize: "180%",
                marginRight: 30,
              }}
              onClick={exportExcel}
            >
              <FileExcelOutlined />
            </a>
          </Tooltip>
          <a href="/create-purchase-request">
            <Button
              style={{ marginRight: 15 }}
              type="primary"
              hidden={!permissions.canAdd}
            >
              Talep Ekle
            </Button>
          </a>
        </Col>
      </Row>

      <PurchaseRequestTableFilter
        data={tableDataQueryOptions.values}
        onClearFilter={onClearTableFilter}
        onFinishFilter={onFinishTableFilter}
        style={{ marginTop: 12, marginBottom: 12 }}
      />
      <Tabs defaultActiveKey={"0"} onChange={onTabChange}>
        <Tabs.TabPane tab="Aktif" key="0" />
        <Tabs.TabPane tab="Onaylanan" key="1" />
        <Tabs.TabPane tab="Reddedilen" key="2" />
      </Tabs>

      <Row>
        <Col span={24}>
          <Table
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            style={{
              overflowX: "auto",
              maxHeight: "100%",
              width: "100%",
            }}
            columns={columns}
            onDataStateChange={dataStateChange}
            dataSource={purchaseRequests.data}
            loading={purchaseRequests.loading}
            pageable={true}
            onChange={paging}
            pagination={{
              defaultPageSize: tableDataQueryOptions.take,
              pageSizeOptions: ["15", "25", "50", "100"],
              total: purchaseRequests.total,
              current: tableDataQueryOptions.current,
            }}
            sortable={true}
            rowKey="id"
          ></Table>
        </Col>
      </Row>

      <Drawer
        id="updatePurchaseRequestDrawer"
        title="Durum Güncelle"
        bodyStyle={{ padding: 24 }}
        width={500}
        onClose={() => setUpdateFormVisibility(false)}
        visible={updateFormVisibility}
      >
        <PurchaseRequestUpdateStatusForm
          data={updateFormData}
          onSuccess={onSuccess}
        />
      </Drawer>
    </>
  );
};

export default PurchaseRequestList;
